import { motion } from 'framer-motion';

/**
 * PageWrapper component for smooth page transitions
 * Wraps page content with Framer Motion animations
 */
const PageWrapper = ({ children }) => {
  // Animation variants for page transitions
  const variants = {
    initial: {
      opacity: 0,
      y: 8
    },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        ease: "easeInOut"
      }
    },
    exit: {
      opacity: 0,
      y: -8,
      transition: {
        duration: 0.2,
        ease: "easeInOut"
      }
    }
  };

  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={variants}
      className="page-wrapper w-full"
    >
      {children}
    </motion.div>
  );
};

export default PageWrapper;
